import React, { useState } from "react";
import "./landing.css";

export default function HeroSection() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="hero">
      <div className="hero-content-section">
        <h1 className="hero-title">
          Radar+ Watches Your Stack <br /> and the Market
        </h1>
        <p className="hero-subtext">
          Internal metrics, external shifts, competitor moves — all monitored and auto-executed before they impact revenue.
        </p>
        {showMore && (
          <p className="hero-subtext">
            RADAR+ continuously scans your internal systems and external shifts — then auto-generates actions to neutralize risks and capture opportunities before they impact your bottom line.
            No blind spots. No missed signals. Just faster, smarter, safer scaling — on autopilot.
          </p>
        )}
        <div className="hero-buttons">
          <button className="primary-btn">
            <span>Get Started</span>
          </button>
          <button
            className="secondary-btn"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? 'Show Less' : 'See how it works →'}
          </button>
        </div>
      </div>
    </div>
  );
}
